/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BankViewIEnumerableResponse } from '../models';
import { InvestigationTypeViewIEnumerableResponse } from '../models';
import { Request } from '../models';
/**
 * ConfigTrustApi - axios parameter creator
 * @export
 */
export const ConfigTrustApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ConfigTrustGetBanksPost: async (body?: Request, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ConfigTrust/GetBanks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ConfigTrustGetInvestigationTypesPost: async (body?: Request, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ConfigTrust/GetInvestigationTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigTrustApi - functional programming interface
 * @export
 */
export const ConfigTrustApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV1ConfigTrustGetBanksPost(body, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationTypeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV1ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConfigTrustApi - factory interface
 * @export
 */
export const ConfigTrustApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any): AxiosPromise<BankViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV1ConfigTrustGetBanksPost(body, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any): AxiosPromise<InvestigationTypeViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV1ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigTrustApi - object-oriented interface
 * @export
 * @class ConfigTrustApi
 * @extends {BaseAPI}
 */
export class ConfigTrustApi extends BaseAPI {
    /**
     * 
     * @param {Request} [body] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV1ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV1ConfigTrustGetBanksPost(body, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Request} [body] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV1ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV1ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
}
